import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store/store';
import { Provider } from 'react-redux';
import { LicenseInfo } from '@mui/x-license';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const licenseKey = process.env.REACT_APP_MUI_X_LICENSE_KEY;
if (licenseKey) {
    LicenseInfo.setLicenseKey(licenseKey);
}

root.render(
  <React.StrictMode>
    <BrowserRouter basename='/'>
        <Provider store={store}>
          <App />
        </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
